import axios from 'src/utils/axios';

import { jwtDecode } from './utils';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from './constant';

export async function setSession(accessToken, refreshToken, tokenExpired) {
    try {
      if (accessToken && refreshToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  
        const decodedToken = jwtDecode(accessToken);
  
        if (decodedToken && 'exp' in decodedToken) {
          tokenExpired(decodedToken.exp);
        } else {
          throw new Error('Invalid access token!');
        }
      } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        delete axios.defaults.headers.common.Authorization;
      }
    } catch (error) {
      console.error('Error during set session:', error);
      throw error;
    }
  }